export default {
    common: {
        title: 'Bewerk Afbeelding',
        cancel: 'Annuleren',
        save: 'Opslaan',
        crop: 'Oogst',
        adjustments: 'Aanpassingen',
        filters: 'Filters',
        frames: 'Frames',
        overlays: 'Overlay',
        text: 'Tekst',
        stickers: 'Stickervellen',
        brush: 'Borstel',
        ai: 'Maak een afbeelding met behulp van AI',
        reset: 'Reset',
        comingSoon: 'Binnenkort beschikbaar...',
        apply: 'Solliciteren',
        undo: 'Ongedaan maken',
        redo: 'Opnieuw doen',
        flipHorizontal: 'Horizontaal omdraaien',
        flipVertical: 'Verticaal spiegelen',
        rotateClockwise: 'Draai met de klok mee',
        rotateAntiClockwise: 'Draai tegen de klok in',
        warning: 'Waarschuwing',
        discard: 'weggooien',
        continue: 'Doorgaan met bewerken',
        discardHeading: 'Wilt u uw wijzigingen negeren?',
        discardSubHeading: 'Als je de beeldbewerker sluit, worden je wijzigingen niet opgeslagen',
        subtitle: 'De ondersteunde beeldformaten zijn PNG en JPEG',
        clone: 'Klonen',
        delete: 'Verwijderen',
    },
};
